module.exports = __webpack_public_path__ + "img/background_principal_pc.31f7972b.png";